import {Typography} from '@mui/material';
import React from 'react';
import AurSvgIcon from '../aur-svg-icon/AurSvgIcon';

interface Props {
  errorText: string;
  errorType?: 'error' | 'warning' | 'success' | 'info';
  showIcon?: boolean;
  textContainerCustomClass?: string;
  hasFullWidth?: boolean;
  renderAction?: () => React.ReactElement;
}

const AurBanner: React.FC<Props> = (props: Props) => {
  const {
    errorText,
    errorType = 'error',
    showIcon = true,
    textContainerCustomClass,
    hasFullWidth = false,
    renderAction,
  } = props;

  return (
    <div
      className={`error-container ${errorType} ${hasFullWidth && 'full-width'}`}
    >
      <div className="error-image-container">
        {showIcon ? (
          <AurSvgIcon
            src={
              errorType === 'success'
                ? '../assests/images/complete.svg'
                : '../assests/images/info.svg'
            }
          />
        ) : (
          ''
        )}
      </div>
      <div
        className={`error-text-container ${textContainerCustomClass} ${hasFullWidth && 'full-width'}`}
        aria-live="polite"
      >
        <Typography
          className={`typo-text ${hasFullWidth ? 'label2_size full-width-typo-text' : 'body3_size'}`}
        >
          {errorText}
        </Typography>
      </div>
      {renderAction && <div className={'action-button'}>{renderAction()}</div>}
    </div>
  );
};

export default AurBanner;
